import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import capitaoSettings from './capitaoSettings.json';
import farol from './farol.json';
import quebras from './quebras.json';
import sandboxV2 from './sandboxV2.json';
import visaoGeral from './visaoGeral.json';
import criticidade from './criticidade.json';
import iaImpact from './iaImpact.json';
import journey from './journey.json';
import satisfacao from './satisfacao.json';
import funilAoVivo from './funilAoVivo.json';
import relatorioExportar from './relatorioExportar.json';
import filtrosRelatorio from './filtrosRelatorio.json';
import retabulacao from './retabulacao.json';
import trocaSenha from './trocaSenha.json';
import pendenciaRelatorio from './pendenciaRelatorio.json';
import presencaRelatorio from './presencaRelatorio.json';
import parceirosAdmin from './parceirosAdmin.json';
import duplicados from './duplicados.json';
import emailTemplatesAdmin from './emailTemplatesAdmin.json';
import fandataCpf from './fandataCpf.json';
import faq from './faq.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import companies from './companies.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import snooze from './snooze.json';
import teamsSettings from './teamsSettings.json';
import tendencia from './tendencia.json';
import whatsappTemplates from './whatsappTemplates.json';
import contentTemplates from './contentTemplates.json';
import mfa from './mfa.json';
import onboarding from './onboarding.json';
import sessionLimit from './sessionLimit.json';
import yearInReview from './yearInReview.json';

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...capitaoSettings,
  ...farol,
  ...quebras,
  ...sandboxV2,
  ...visaoGeral,
  ...criticidade,
  ...iaImpact,
  ...journey,
  ...satisfacao,
  ...funilAoVivo,
  ...relatorioExportar,
  ...filtrosRelatorio,
  ...retabulacao,
  ...trocaSenha,
  ...pendenciaRelatorio,
  ...presencaRelatorio,
  ...parceirosAdmin,
  ...duplicados,
  ...emailTemplatesAdmin,
  ...fandataCpf,
  ...faq,
  ...cannedMgmt,
  ...chatlist,
  ...companies,
  ...components,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...snooze,
  ...teamsSettings,
  ...tendencia,
  ...whatsappTemplates,
  ...contentTemplates,
  ...mfa,
  ...onboarding,
  ...sessionLimit,
  ...yearInReview,
};
